import {Component, Inject, OnInit, signal, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PushpinImage} from '../../classes/pushpin-image.class';
import {ApiService} from '../../services/api/api.service';
import {DrawOnImageComponent} from '../../draw-on-image/draw-on-image.component';
import {Settings} from '../../settings.class';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {MatTooltip} from "@angular/material/tooltip";

@Component({
    selector: 'app-draw-on-image-dialog',
    templateUrl: './draw-on-image-dialog.component.html',
    styleUrls: ['./draw-on-image-dialog.component.scss'],
    imports: [
        MatTooltip,
        DrawOnImageComponent
    ]
})
export class DrawOnImageDialogComponent implements OnInit {

    @ViewChild('draw') draw: DrawOnImageComponent;

    readonly width = signal<number>(0);
    readonly height = signal<number>(0);

    readonly saving = signal<boolean>(false);
    readonly showSave = signal<boolean>(true);

    readonly editImage = signal<string>(null);

    constructor(
        public dialogRef: MatDialogRef<DrawOnImageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public image: PushpinImage,
        private confirmDialog: ConfirmDialogService,
        private apiService: ApiService
    ) {
    }

    ngOnInit(): void {
        const imageContainer = document.querySelector('.image-viewer-container');

        this.width.set(imageContainer.clientWidth);
        this.height.set(imageContainer.clientHeight);

        if (this.image.drawn_image) {
            this.confirmDialog.confirm('Bestaande markering',
                `Er zijn al markeringen aangebracht op deze foto. Wilt u die behouden?`,
                'Behouden',
                'Verwijderen').then(() => {
                this.editImage.set(this.image.drawn_image);
            }, () => {
                this.editImage.set(this.image.image);
            });
        } else {
            this.editImage.set(this.image.image);
        }
    }

    save() {
        this.draw.save().then(drawnImage => {
            this.apiService.postCall$(`images`, {base64: drawnImage.base64})
                .subscribe((imageUrl: object) => {
                    this.image.drawn_image = `${Settings.API_ENDPOINT}${imageUrl['imageUrl']}`;
                    this.dialogRef.close(this.image);
                }, error => {

                });
        }, () => {

        });
    }

}
